module.exports = __webpack_public_path__ + "static/img/pic41.d4113498.png";